import { render, staticRenderFns } from "./inspectionInspector.vue?vue&type=template&id=2736b062&"
import script from "./inspectionInspector.vue?vue&type=script&lang=js&"
export * from "./inspectionInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports